module.exports = __webpack_public_path__ + "static/media/media.a565e1e6.svg";